import styled, { css } from 'styled-components'
import { BP } from 'resources/constants'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { sectionCss } from 'app/sofia/components/Structure/Section'
import { heading1, heading2, link, buttonGreen, buttonPrimaryOutline, buttonSizeLg } from 'app/sofia/resources/theme/css'

// icons
import icon1 from './images/icons/1.svg'
import icon2 from './images/icons/2.svg'
import icon3 from './images/icons/3.svg'
import icon4 from './images/icons/4.svg'
import icon5 from './images/icons/5.svg'
import icon6 from './images/icons/6.svg'
import icon7 from './images/icons/7.svg'
import icon8 from './images/icons/8.svg'
import icon9 from './images/icons/9.svg'
import icon10 from './images/icons/10.svg'
import icon11 from './images/icons/11.svg'
import icon12 from './images/icons/12.svg'
import icon13 from './images/icons/13.svg'
import icon14 from './images/icons/14.svg'
import icon15 from './images/icons/15.svg'
import icon16 from './images/icons/16.svg'

export const iconCss = css`
  svg + span,
  span + svg { margin-left: 8px; }

  svg {
    height: 11px;
    width: 11px;

    path {
      fill: ${props => props.theme.palette.primary.alphaDark};
    }
  }

  &:hover,
  &:focus,
  &:active {
    svg {
      path {
        fill: ${props => props.theme.palette.primary.alpha};
      }
    }
  }
`

export const Button = styled.button`
  ${buttonGreen}
  ${buttonSizeLg}
  display: inline-flex;

  &.link {
    ${link};
    height: auto;
    cursor: pointer;
    padding: 0;
    margin: 0;
    border: 0;
    background: none;
    font-weight: 600;
    text-decoration: none;
    font-size: 17px;
    ${iconCss}
  }

  &.results-back {
    position: absolute;
    z-index: 9;

    @media (max-width: ${BP.sm.max}) {
      left: 15px;
      top: 15px;
      ${link}
      text-decoration: none;
      background: none;
      height: auto;
      padding: 0;
      font-size: 16px;
      border: 0;
      font-weight: 600;
    }

    @media (min-width: ${BP.sm.min}) {
      ${buttonPrimaryOutline};
      left: 30px;
      top: 30px;
    }
  }

  .icon {
    ${iconCss}
  }
`

export const Section = styled.section`
  ${sectionCss};
  min-height: 50vh;
  position: relative;
  width: 100%;

  @media (min-width: ${BP.sm.min}) {
    margin-bottom: 15px;
  }
`

export const Container = styled.div`
  ${containerCss};

  @media (min-width: ${BP.sm.min}) {
    margin-bottom: 20px;
  }

  @media (min-width: ${BP.md.min}) {
    margin-bottom: 40px;
  }
`

export const SelectorContent = styled.div`
  margin: 0 auto;

  @media (min-width: ${BP.sm.min}) {
    width: ${BP.xs.min};
  }
`

export const ContentBlock = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.075);

  @media (min-width: ${BP.sm.min}) {
    padding: 30px;
  }
`

export const itemPressedCss = css`
  box-shadow: inset 0 3px 3px rgba(0, 0, 0, 0.2);
  border-color: ${props => props.theme.palette.primary.alphaDark};
  background: ${props => props.theme.palette.primary.alphaLight};
`

export const itemSelectedCss = css`
  border-color: ${props => props.theme.palette.primary.beta};
  background: ${props => props.theme.palette.primary.greyExtraLight};
`

export const Items = styled.div`
  --itemSize: 60px;

  label {
    position: relative;
    display: block;
    cursor: pointer;

    input {
      position: absolute;
      left: -30px;
      opacity: 0;
      visibility: hidden;

      &:checked + .item {
        ${itemSelectedCss}

        > .icon-wrap .icon {
          background-color: ${props => props.theme.palette.primary.beta};
        }
      }
    }

    & + label {
      margin-top: 10px;
    }
  }

  .item {
    background: #fff;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 3px solid transparent;

    @media (min-width: ${BP.sm.min}) {
      padding: 15px;
    }

    &:hover {
      border-color: ${props => props.theme.palette.primary.alphaDark};
    }

    > .icon-wrap {
      margin-right: 15px;

      @media (min-width: ${BP.sm.min}) {
        margin-right: 20px;
      }

      > .icon {
        padding: 5px;
        border-radius: 10px;
        width: calc(var(--itemSize) - 6px);
        height: calc(var(--itemSize) - 6px);
        text-align: center;
        display: flex;
        align-items: center;
        background-color: ${props => props.theme.palette.primary.alphaDark};
        background-size: auto;
        background-repeat: no-repeat;
        background-position: center;

        @media (min-width: ${BP.sm.min}) {
          width: var(--itemSize);
          height: var(--itemSize);
        }

        &.icon-1 { background-image: url(${icon1}); }
        &.icon-2 { background-image: url(${icon2}); }
        &.icon-3 { background-image: url(${icon3}); }
        &.icon-4 { background-image: url(${icon4}); }
        &.icon-5 { background-image: url(${icon5}); }
        &.icon-6 { background-image: url(${icon6}); }
        &.icon-7 { background-image: url(${icon7}); }
        &.icon-8 { background-image: url(${icon8}); }
        &.icon-9 { background-image: url(${icon9}); }
        &.icon-10 { background-image: url(${icon10}); }
        &.icon-11 { background-image: url(${icon11}); }
        &.icon-12 { background-image: url(${icon12}); }
        &.icon-13 { background-image: url(${icon13}); }
        &.icon-14 { background-image: url(${icon14}); }
        &.icon-15 { background-image: url(${icon15}); }
        &.icon-16 { background-image: url(${icon16}); }
      }
    }

    > .label {
      &._no-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        text-align: center;
        min-height: calc(var(--itemSize) - 6px);

        @media (min-width: ${BP.sm.min}) {
          min-height: var(--itemSize);
        }
      }

      p {
        font-weight: 400;
        font-size: 16px;
        margin: 0;
        line-height: 1.2;

        strong {
          font-weight: 600;
        }

        @media (min-width: ${BP.sm.min}) {
          font-size: 18px;
        }
      }
    }

    &.result {
      > .icon-wrap {
        margin: auto 10px auto auto;

        svg {
          width: 20px;
          height: 20px;
          fill: ${props => props.theme.palette.primary.alphaDark};
        }
      }
    }
  }
`

export const Actions = styled.div`
  .submit-wrap {
    text-align: center;
    margin-top: 15px;
  }

  .nav-wrap {
    margin-top: 25px;
    display: flex;

    > div {
      flex: 1;

      &:last-child {
        text-align: right;
      }
    }
  }

  a,
  .clickable {
    ${link}
    font-weight: 600;
    text-decoration: none;
    ${iconCss}
    cursor: pointer;
  }
`

export const Header = styled.header`
  text-align: center;
  margin-bottom: 25px;

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: ${props => props.theme.font.alt.family};
    font-weight: 400;
  }

  h1,
  h2 {
    ${heading1}
    line-height: 1.1;
    margin: 0 0 15px;

    @media (min-width: ${BP.sm.min}) {
      margin-bottom: 15px;
    }
  }

  h3,
  h4,
  h5 {
    ${heading2}
    line-height: 1.3;
    margin: 0 0 15px;

    @media (min-width: ${BP.sm.min}) {
      margin-bottom: 20px;
    }
  }

  p {
    margin: 0 0 15px;
    font-size: 18px;
    line-height: 1.35;

    &:last-child {
      margin: 0;
    }
  }
`

export const SliderContainer = styled.div`
  padding: 0 20px;

  > div[class*='Slider'] {
    width: 100%;
    background: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);

    > div {
      &:first-child {
        background: #fff;
      }

      &:last-child {
        > div {
          height: 28px;
          width: 28px;
          position: relative;
          background: #fff;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);

          &::after {
            content: '';
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background: ${props => props.theme.palette.primary.alphaDark};
            position: absolute;
            left: 5px;
            top: 5px;
          }
        }
      }
    }
  }

  .slider-info {
    margin-top: 20px;
    text-align: center;
    position: relative;

    .mm {
      position: absolute;
      top: 0;
      font-weight: 600;
      font-size: 22px;

      &._min { left: 0; }
      &._max { right: 0; }
    }

    input {
      text-align: center;
      padding: 10px;
      border-radius: 5px;
      border: 1px solid ${props => props.theme.palette.general.borderColorLight};
      width: 150px;
      height: 55px;
      box-sizing: border-box;
      font-size: 20px;
      margin-top: 20px;
      outline: none;
      background: #fff;
      cursor: default;

      &:focus,
      &:active {
        background: #fff;
        border: 1px solid ${props => props.theme.palette.general.borderColorLight};
      }
    }
  }
`
